import LTR from "@brand-icons/global/stars-shinning/stars-shinning-ltr.svg";
import RTL from "@brand-icons/global/stars-shinning/stars-shinning-rtl.svg";

import { iconFactory } from "../iconFactory";

export const StarsShinningIcon = iconFactory("StarsShinningIcon", LTR, RTL);
